import { QueryClientProvider } from '@tanstack/react-query'
import { Navigate, Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { Provider } from 'jotai'
import { useEffect } from 'react'
import LoadingScreenProvider from '~components/root/loading-screen-provider'
import ToastComponent from '~components/ui/toast'
import useDarkMode from '~hooks/use-dark-mode'
import { queryClient, store } from '~store/general'

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <Navigate to="/404" />,
})

function RootComponent() {
  const isDarkMode = useDarkMode()

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [isDarkMode])

  return (
    <>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <main className="w-full h-[100vh]">
            <Outlet />
          </main>
        </QueryClientProvider>
      </Provider>
      <div id="dialog" />
      <div id="toast" />
      <div id="modal" />
      <ToastComponent />
      <LoadingScreenProvider />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}
